<template>
    <div class="contact-form">
        <v-dialog v-model="dialog_sent" width="400" persistent>
            <v-card>
                <v-card-title class="subheading success lighten-2" primary-title>
                    <v-icon left>how_to_vote</v-icon>
                    <span class="font-weight-medium">Сообщение отправлено</span>
                </v-card-title>
                <v-card-text class="text-xs-center">
                    <p>Ваше сообщение успешно отправлено.</p>
                    <p>Мы обработаем его в ближайшее время.</p>
                    <v-divider></v-divider>
                    <p></p>
                    <p></p>
                </v-card-text>
                <v-card-actions class="bg_navbar">
                    <v-layout row wrap justify-end>
                        <v-flex xs12 md4>
                            <v-btn block color="secondary" flat @click="close_form">
                                Закрыть
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_form"
                  fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar flat dark color="accent">
                    <v-toolbar-title>
                        <v-icon>message</v-icon>
                        Форма обратной связи
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon dark @click="close_form">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-form ref="contact_form" v-model="valid" lazy-validation>
                    <v-card-text>
                        <v-container grid-list-md fluid>
                            <v-layout row wrap justify-space-around align-center>
                                <v-flex xs12 sm8 md4>
                                    <small>*Обязательные поля</small>
                                    <v-select box
                                            v-model="form_model.section"
                                            :items="selector_section"
                                            :rules="rules.required"
                                            label="Направление*" required
                                    ></v-select>
                                    <v-text-field
                                            v-model="form_model.email" color="accent"
                                            placeholder="example@contoso.com"
                                            :rules="rules.email"
                                            label="Контактный E-mail*" required
                                    ></v-text-field>
                                    <v-text-field
                                            v-model="form_model.contact_name" color="accent"
                                            label="Ваше имя"
                                    ></v-text-field>
                                    <v-text-field
                                            v-model="form_model.contact_phone" color="accent"
                                            placeholder="+7 (987) 654 - 3210 доб. 1234"
                                            hint="В любом формате"
                                            label="Телефон для связи"
                                    ></v-text-field>
                                    <br>
                                    <v-divider></v-divider>
                                    <br>
                                    <v-text-field
                                            v-model="form_model.header" color="accent"
                                            label="Заголовок сообщения*"
                                            hint="Тема сообщения, например 'Вопрос по товару'"
                                            :rules="rules.header" counter="256" required
                                    ></v-text-field>
                                    <v-textarea
                                            v-model="form_model.text" color="accent"
                                            name="input-text"
                                            label="Текст сообщения*"
                                            hint="Произвольный текст"
                                            :rules="rules.text" counter="1024"
                                            auto-grow rows="3" required
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="bg_navbar">
                        <v-container class="mx-2" fluid>
                            <v-layout wrap pa-1 align-center justify-center column fill-height>
                                <v-flex>
                                    <template v-if="!is_logged_in">
                                        <vue-recaptcha class="hidden-xs-only"
                                                       theme="light" size="normal"
                                                       ref="recaptcha"
                                                       @verify="onVerify"
                                                       @expired="onExpired"
                                                       :sitekey="sitekey">
                                        </vue-recaptcha>
                                        <vue-recaptcha class="hidden-sm-and-up"
                                                       theme="light" size="compact"
                                                       ref="recaptcha"
                                                       @verify="onVerify"
                                                       @expired="onExpired"
                                                       :sitekey="sitekey">
                                        </vue-recaptcha>
                                        <br/>
                                        <v-btn block large color="success" fill-height
                                               :disabled="!valid || !recaptcha" @click="validate">
                                            <span class="subheading font-weight-medium">Отправить</span>
                                            <v-icon right medium>send</v-icon>
                                        </v-btn>
                                    </template>
                                    <template v-else>
                                        <v-btn block large color="success" fill-height
                                               :disabled="!valid" @click="validate">
                                            <span class="subheading font-weight-medium">Отправить</span>
                                            <v-icon right medium>send</v-icon>
                                        </v-btn>
                                    </template>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <a @click="show_form"
           class="text-xs-center caption mx-3 accent--text">
            <v-icon small class="accent--text">message</v-icon>
            Форма обратной связи
        </a>
        <v-snackbar v-model="snack" :timeout="10000" :color="snackColor">
            {{ snackText }}
            <v-btn flat @click="snack = false" :ripple="false">Закрыть</v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import $ from 'jquery'
    import { Globals } from '@/globals.js';
    import VueRecaptcha from 'vue-recaptcha';
    export default {
        name: "ContactForm",
        data(){
            return {
                form_model: {
                    contact_name: '',
                    contact_phone: '',
                    email: '',
                    section: 'sellers',
                    header: '',
                    text: '',
                },
                dialog_form: false,
                dialog_sent: false,
                selector_section: [
                    {id: 1, value: 'sellers', text: 'Отдел продаж'},
                    {id: 2, value: 'buyers', text: 'Отдел закупок'},
                    {id: 3, value: 'logist', text: 'Служба логистики'},
                    {id: 4, value: 'service', text: 'Сервис-центр'},
                    {id: 5, value: 'accounting', text: 'Бухгалтерия'},
                    {id: 6, value: 'support', text: 'Тех.поддержка'},
                ],
                rules: {
                    header: [
                        v => !!v || 'Это поле обязательно для заполнения',
                        v => (v && v.length <= 256) || `Слишком большое сообщение. Максимум 256 символов.`
                    ],
                    text: [
                        v => !!v || 'Это поле обязательно для заполнения',
                        v => (v && v.length <= 1024) || `Слишком большое сообщение. Максимум 1024 символов.`
                    ],
                    required: [
                        v => !!v || 'Это поле обязательно для заполнения',
                    ],
                    email: [
                        v => !!v || 'Это поле обязательно для заполнения',
                        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Некоректный E-mail'
                    ],
                },
                // Validate
                valid: false,
                recaptcha: false,
                recaptcha_validation: '',
                sitekey: Globals.RECAPTCHA_SITE_KEY,
                // Snack
                snack: false,
                snackColor: '',
                snackText: '',
            }
        },
        components: {
            VueRecaptcha,
        },
        computed: {
            is_logged_in() { return this.$store.getters.logged_state },
            user_info() { return this.$store.getters.user_info_get},
        },
        mounted() {
            if(this.is_logged_in) {
                this.fill_form_defaults();
            }
        },
        methods: {
            send_mail(send_info, recaptcha_validation) {
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.MAIN + 'service/contact/',
                    type: 'POST',
                    data: {
                        form_info: send_info,
                        validation: recaptcha_validation,
                    },
                    success: () => {
                        this.show_snack('success', 'Сообщение отправлено');
                        this.resetForm();
                        this.dialog_sent = true;
                    },
                    error: (response) => {
                        this.show_snack('error', 'Ошибка: ' + response.status);
                    },
                })
            },
            // Validations
            validate() {
                if (this.$refs.contact_form.validate()) {
                    if(this.recaptcha && !this.is_logged_in)
                        this.send_mail(this.form_model, this.recaptcha_validation);
                    if(this.is_logged_in)
                        this.send_mail(this.form_model, 'user_logged_in');
                }
            },
            // RE-Captcha
            onVerify: function (response) {
                //console.log('Verify: ' + response);
                this.recaptcha_validation = response;
                this.recaptcha = true;
            },
            onExpired: function () {
                //console.log('Expired')
                this.recaptcha_validation = '';
                this.recaptcha = false;
            },
            resetRecaptcha() {
                this.recaptcha = false;
                this.recaptcha_validation = '';
                this.$refs.recaptcha.reset() // Direct call reset method
            },
            // Form Reset
            resetForm() {
                this.$refs.contact_form.reset();
                if(!this.is_logged_in)
                    this.resetRecaptcha();
            },
            // Form MISC
            show_form() {
                this.dialog_form = true;
                if (this.is_logged_in) {
                    this.fill_form_defaults();
                }
            },
            fill_form_defaults() {
                if (this.form_model.contact_name === '')
                    this.form_model.contact_name = this.user_info.name_owner;
                if (this.form_model.email === '')
                    this.form_model.email = this.user_info.user.email;
            },
            close_form() {
                this.dialog_sent = false;
                this.dialog_form = false;
            },
            show_snack(snack_color, snack_text){
                this.snack = true;
                this.snackColor = snack_color;
                this.snackText = snack_text;
            },
        },
    }
</script>

<style scoped>

</style>